const getters = {
  findBroadcastById: (state) => (broadcastListId) => {
    const broadcast = state.broadcastList.find(
      (broadcast) => broadcast.whatsapp_broadcast_list_id == broadcastListId,
    );
    return broadcast;
  },
};

export default getters;
